import { IReduxAction } from '../IReduxAction'
import ActionTypes from './types'

export interface IPlusUserState {
  isPlusUser: boolean
  loaded: boolean
}

export const initState: IPlusUserState = {
  isPlusUser: false,
  loaded: false
}

export default (state = initState, action: IReduxAction): IPlusUserState => {
  switch (action.type) {
    case ActionTypes.add_is_plus_user:
      return {
        loaded: true,
        isPlusUser: action.payload.data
      }

    case ActionTypes.clear_is_plus_user: {
      return {
        loaded: false,
        isPlusUser: initState.isPlusUser
      }
    }

    case ActionTypes.clear_loaded: {
      return {
        ...state,
        loaded: false
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/plusUsers/index.ts